const getCrypto = () => {
  return window.crypto || window.msCrypto;
};

export const createRandomString = (length: number): string => {
  const charset =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.';
  let randomString = '';

  const randomValues = Array.from(
    getCrypto().getRandomValues(new Uint8Array(length))
  );

  randomValues.forEach((randomValue) => {
    randomString += charset[randomValue % charset.length];
  });

  return randomString;
};

export const decode = (value: string) => {
  return atob(value);
};

export const encode = (value: string) => {
  return btoa(value);
};
